<template>
    <div>
        <!-- 搜索 -->
        <div class="search">
            <div class="condition">
                <div class="condition-item">
                    <div class="label">年级:</div>
                    <a-select mode="multiple" placeholder="请选择" v-model="queryParam.gradeTagId" ref="select"
                        class="select-box">
                        <a-select-option v-for="(item, index) in schoolGradeList" :key="index" :value="item.gradeTagId">
                            {{ item.gradeName }}
                        </a-select-option>
                    </a-select>
                </div>
                <div class="condition-item">
                    <div class="label">学员:</div>
                    <a-input placeholder="请输入" v-model="queryParam.studentName" style="flex: 1;"></a-input>
                </div>
                <div class="condition-item">
                    <div class="label">完成状态:</div>
                    <a-select class="form-cell" placeholder="请选择" v-model="queryParam.status" @change="$forceUpdate()"
                        style="flex: 1;">
                        <a-select-option value="">全部</a-select-option>
                        <a-select-option value="0">未完成</a-select-option>
                        <a-select-option value="1">已完成</a-select-option>
                    </a-select>
                </div>
            </div>
            <div class="search-operate">
                <a-button type="primary" @click="getParentSummary">查询</a-button>
            </div>
        </div>
        <div class="export">
            <a @click="exportExcel">导出结果</a>
        </div>
        <!-- 表格 -->
        <div class="table">
            <a-table :columns="columns" :dataSource="tableData" class="c-table" :pagination="pagination"
                :rowKey="getRowKey" @change="tableChange">
                <template slot="userId" slot-scope="text, record">
                    {{ record.userId == 0 ? '未提交' : '已提交' }}
                </template>
                <template slot="updateTime" slot-scope="text, record">
                    {{ record.userId == 0 ? '暂未填写' : record.updateTime }}
                </template>
            </a-table>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import { downloadExcelFile } from '../../../utils'
import { Empty } from 'ant-design-vue';
import questionnaire from '../../../api/questionnaire';
const columns1 = [
    {
        title: '姓名',
        dataIndex: 'studentName',
        key: 'studentName',
    },
    {
        title: '年级',
        dataIndex: 'grade',
        key: 'grade',
    },
    {
        title: '原始班级',
        dataIndex: 'className',
        key: 'className',
    },
    {
        title: '提交状态',
        dataIndex: 'userId',
        key: 'userId',
        scopedSlots: { customRender: 'userId' },
    },
    {
        title: '提交时间',
        dataIndex: 'updateTime',
        key: 'updateTime',
        scopedSlots: { customRender: 'updateTime' },
    }
]
const columns2 = [
    {
        title: '姓名',
        dataIndex: 'studentName',
        key: 'studentName',
    },
    {
        title: '年级',
        dataIndex: 'grade',
        key: 'grade',
    },
    {
        title: '原始班级',
        dataIndex: 'className',
        key: 'className',
    },
    {
        title: '班级名称',
        dataIndex: 'teaClassName',
        key: 'teaClassName',
    },
    {
        title: '提交状态',
        dataIndex: 'userId',
        key: 'userId',
        scopedSlots: { customRender: 'userId' },
    },
    {
        title: '提交时间',
        dataIndex: 'updateTime',
        key: 'updateTime',
        scopedSlots: { customRender: 'updateTime' },
    }
]
export default {
    name: 'QuestionFormList',
    props: {
        formId: {
            type: Number
        },
        type: {
            type: Number
        }
    },
    data() {
        return {
            columns:[],
            schoolGradeList: Vue.ls.get('schoolGrade'),
            queryParam: {},
            tableData: [],
            pagination: {
                pageSize: 10,
                total: 0,
                showTotal: total => `总共 ${total} 条`, // 显示总数
                showSizeChanger: true,
                pageSizeOptions: ['10', '20', '30', '50', '70', '100'],
                current: 1,
                currentPage: 1,
            }, // 分页数据对象
            simpleImage: Empty.PRESENTED_IMAGE_SIMPLE,
        }
    },
    created() {
        this.columns = (this.type == 0 || this.type == 7) ? columns1 : columns2
        this.getParentSummary()
    },
    methods: {
        // 家长评分表
        async getParentSummary() {
            let params = {
                id: this.formId,
                currentPage: this.pagination.currentPage,
                pageSize: this.pagination.pageSize,
                schoolId: Vue.ls.get('schoolId'),
                studentName: this.queryParam.studentName ? this.queryParam.studentName : '',
                gradeIds: this.queryParam.gradeTagId ? this.queryParam.gradeTagId : '',
                submit: this.queryParam.status ? this.queryParam.status : ''
            }
            const { data } = await questionnaire.getParentSummary(params)
            this.tableData = data.list
            this.pagination.total = data.pagination.total
        },
        getRowKey(record, index) {
            return index;
        },
        tableChange(pagination) {
            this.pagination.current = pagination.current
            this.pagination.currentPage = pagination.current
            this.pagination.pageSize = pagination.pageSize
            this.getParentSummary()
        },
        // 导出excel
        exportExcel() {
            let gradeIds = this.queryParam.gradeTagId? this.queryParam.gradeTagId.join(',') : ''
            let params = {
                id: this.formId,
                schoolId: Vue.ls.get('schoolId'),
                studentName: this.queryParam.studentName ? this.queryParam.studentName : '',
                gradeIds: gradeIds,
                submit: this.queryParam.status ? this.queryParam.status : ''
            }
            downloadExcelFile(
                '/api/teaTermEvaluation/exportStudentEvaluationSource',
                '问卷清单.xlsx',
                params
            )
        },
    }
}
</script>

<style lang="less" scoped>
// ::v-deep .ant-table {
//     font-size: 16px !important;
// }
.search {
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .condition {
        display: flex;
        flex: 1;
    }

    .condition-item {
        display: flex;
        align-items: center;
        margin-right: 12px;

        .label {
            margin-right: 12px;
        }
    }

    .search-operate {

        .btn {
            height: 32px;
            padding-top: 5px;
            margin-bottom: 12px;
        }
    }
}

.export {
    text-align: right;
    padding-right: 5px;
    margin-bottom: 12px;
}

.select-box {
    min-width: 200px;
    max-width: 300px;
}
</style>